<script lang="ts">
  /**
   * HotkeyBar — bottom bar showing available hotkeys.
   * Each entry is a tappable button for mobile support.
   */

  interface HotkeyEntry {
    key: string;
    label: string;
    active: boolean;
  }

  interface Props {
    keys: HotkeyEntry[];
    onOverlay?: (key: string) => void;
  }

  let { keys, onOverlay }: Props = $props();

  function handleTap(entry: HotkeyEntry): void {
    if (!entry.active) return;
    onOverlay?.(entry.key.toLowerCase());
  }
</script>

<div class="hotkey-bar">
  {#each keys as entry}
    <button
      class="hotkey-bar__item"
      class:hotkey-bar__item--dim={!entry.active}
      disabled={!entry.active}
      onclick={() => handleTap(entry)}
    >
      <span class="hotkey-bar__key">{entry.key}</span>:<span class="hotkey-bar__label"
        >{entry.label}</span
      >
    </button>
  {/each}
</div>

<style>
  .hotkey-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.35rem 1rem;
    border-top: 1px solid var(--fg-dim);
    font-family: var(--font-mono);
    font-size: 0.8rem;
    color: var(--fg);
    background: var(--bg);
    flex-shrink: 0;
  }

  .hotkey-bar__item {
    white-space: nowrap;
    background: none;
    border: 1px solid var(--fg-dim);
    color: var(--fg);
    font-family: var(--font-mono);
    font-size: 0.8rem;
    cursor: pointer;
    padding: 0.3rem 0.6rem;
    min-height: 44px;
    display: flex;
    align-items: center;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .hotkey-bar__item:active {
    background: rgba(51, 255, 51, 0.15);
  }

  .hotkey-bar__item--dim {
    color: var(--fg-dim);
    border-color: transparent;
    cursor: default;
  }

  .hotkey-bar__item--dim:active {
    background: none;
  }

  .hotkey-bar__key {
    font-weight: bold;
    color: var(--fg-bright);
  }

  .hotkey-bar__item--dim .hotkey-bar__key {
    color: var(--fg-dim);
  }

  .hotkey-bar__label {
    margin-left: 0.1rem;
  }

  @media (max-width: 600px) {
    .hotkey-bar {
      justify-content: center;
      gap: 0.35rem;
      padding: 0.25rem 0.5rem;
    }

    .hotkey-bar__item {
      font-size: 0.75rem;
      padding: 0.25rem 0.5rem;
    }
  }
</style>
